import React from 'react'

const Link = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8506 17.1989C11.1941 15.5358 11.3437 12.6892 13.1838 10.8424L18.5163 5.49021C20.3564 3.64234 23.1909 3.49275 24.8485 5.15474C26.5061 6.81672 26.3554 9.66442 24.5152 11.5123L21.849 14.1884" stroke="currentColor" strokeLinecap="round" strokeWidth="1.875"></path>
            <path d="M17.1493 12.7998C18.8057 14.4629 18.6561 17.3095 16.816 19.1563L14.1498 21.8324L11.4835 24.5085C9.64338 26.3564 6.80888 26.5059 5.15129 24.844C3.49371 23.182 3.6444 20.3343 5.48457 18.4864L8.15078 15.8103" opacity="0.5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.875"></path>
        </svg>
    )
}

export default Link
